import { safeParseJson } from "./json_utils";

/**
 * Get a user-friendly error message from any error.
 *
 * It extracts the message from a JSON string if necessary,
 * so that it works with errors thrown by unsuccessful API calls
 * (onRequestError will be called with an Error object with a message property
 * containing the response JSON as string)
 */
export function getMessageFromError(error) {
  try {
    if (typeof error === 'string') {
      return parseMessageFromJsonString(error);
    }
    else if (error instanceof Error) {
      return parseMessageFromJsonString(error.message);
    }
    else if (error && error.message) {
      return error.message;
    }
  }
  catch (e) {
  }
}

export function parseMessageFromJsonString(error) {
  if (!error || typeof error !== 'string') {
    return;
  }
  let parsed = safeParseJson(error);
  if (parsed && parsed.message) {
    return parsed.message || parsed.error.toString() || error;
  }
  return error;
}
